import { render, staticRenderFns } from "./SafetyIncidentTable.vue?vue&type=template&id=271bac90"
import script from "./SafetyIncidentTable.vue?vue&type=script&lang=js"
export * from "./SafetyIncidentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports